export function getZoomCropImage (image, size = 800, notFound = 'https://s.pixfs.net/common/ppage/image/notfound.png') {
    if (!Boolean(image) || image.match('https://imageproxy.pimg.tw/') || image.match('https://imageproxy.pixnet.cc')) return image;
    return `https://imageproxy.pimg.tw/zoomcrop?url=${encodeURI(image)}&format=webp&width=${size}&height=${size}&default_url=${notFound}`;
}

/** 文章無圖時的預設回應 */
export const ARTICLE_DEFAULT_IMG = "https://imageproxy.pimg.tw/zoomcrop?url=https://s.pixfs.net/common/ppage/image/notfound.png&width=800&height=800";
